/**
 * Open a link an admin typed into a sheet or a push: a Portal path goes through the router, a
 * website opens in a new tab, mailto / tel hand off to the OS. One place, because the resolver
 * (`resolveAppLink`) lets all three through and each needs a different door.
 */
export const isExternalLink = (href) => /^(https?:\/\/|mailto:|tel:)/i.test(href || '');

export default function openAppLink(navigate, href) {
  if (!href) return;
  if (/^https?:\/\//i.test(href)) { window.open(href, '_blank', 'noopener'); return; }
  if (/^(mailto|tel):/i.test(href)) { window.location.assign(href); return; }
  navigate(href);
}
